export const INTERVIEW_TYPE_IDS = {
  FaceToFace: 1,
  RemoteVideo: 2
};
